import * as React from "react";
import {connect} from "react-redux";
import {RouteComponentProps} from "react-router";
import {Action, Dispatch} from "redux";
import {Multi_SkillTag} from "src/domain/model/skill_tag";
import {createCustomerMypageActionCreator} from "../action/customer_mypage_action";
import CustomerMypageComponent from "../component/customer/mypage/customer_mypage";
import {createCustomerMypageDispatcher, ICustomerMypageDispatcher,} from "../dispatcher/customer_mypage_dispatcher";
import {
  DestroyCustomerPDFByCustomerRequest,
  GenerateCustomerPDFByCustomerRequest,
  UpdateCustomerByCustomerRequest,
  UpdateEmailByCustomerRequest,
  UpdatePasswordByCustomerRequest,
} from "../request/mypage_request";
import {AppState} from "../store/app_state";
import {AuthState} from "../store/auth_state";
import {CustomerMypageState} from "../store/customer_mypage_state";

interface IProps extends RouteComponentProps<{ action: string }> {
    state: CustomerMypageState;
    authState: AuthState;
    dispatcher: ICustomerMypageDispatcher;
}

interface IState {
    isInit: boolean;
}

export class CustomerMypage extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            isInit: true,
        };
    }

    public componentDidMount() {
        this.props.dispatcher.getMeCustomer();
    }

    public componentDidUpdate(prevProps: IProps, prevState: IState) {
        // init処理の終了
        const isInitFinished: boolean =
            this.state.isInit &&
            !this.props.state.isLoading &&
            prevProps.state.isLoading;
        if (isInitFinished) {
            return this.setState({isInit: false});
        }
    }

    public render(): JSX.Element {
        const {location, match, state} = this.props;
        const {isInit} = this.state;

        const {customer, jobCareers, pastCaseProjects, blobURL, isLoading} =
            state;

        return (
            <CustomerMypageComponent
                isInit={isInit}
                isLoading={isLoading}
                location={location}
                match={match}
                customer={customer}
                jobCareers={jobCareers}
                pastCaseProjects={pastCaseProjects}
                blobURL={blobURL}
                handleUpdateCustomerSubmit={this.handleUpdateCustomerSubmit}
                handleUpdatePasswordSubmit={this.handleUpdatePasswordSubmit}
                handleUpdateEmailSubmit={this.handleUpdateEmailSubmit}
                handleGenerateCustomerPDF={this.handleGenerateCustomerPDF}
                handleDestroyCustomerPDF={this.handleDestroyCustomerPDF}
            />
        );
    }

    // Customerデータ編集用
    private handleUpdateCustomerSubmit = (values: any): void => {
        if (this.props.authState.user === null) {
            return;
        }

        const req: UpdateCustomerByCustomerRequest =
            new UpdateCustomerByCustomerRequest();

        req.name = values.customer.name;
        req.nameKana = values.customer.nameKana;
        req.iconURL = values.customer.gsIconURL;
        req.birthdate = values.customer.birthdate;
        req.gender = values.customer.gender;
        req.phoneNumber = values.customer.phoneNumber;
        req.pr = values.customer.pr;
        req.address = values.customer.address;
        req.academicBackgrounds = [String(values.customer.academicBackgrounds)];
        req.requirements = [String(values.customer.requirements)];
        req.languages = values.customer.languages;
        req.moreLanguage = values.customer.moreLanguage;
        req.speakingLevel = values.customer.speakingLevel;
        req.resumeURL = values.customer.resumeURL;
        req.jobHistoryURL = values.customer.jobHistoryURL;
        req.workingFrequency = values.customer.workingFrequency;
        req.requestedFee = values.customer.requestedFee;
        req.requestedCondition = values.customer.requestedCondition;
        req.dutySummary = values.customer.dutySummary;
        req.uploadFileIconURL = values.iconURLFileObject;
        req.jobCareers = values.jobCareers;
        req.pastCaseProjects = values.pastCaseProjects;
        req.workIntention = values.customer.workIntention;
        req.fullTimePossibility = values.customer.fullTimePossibility;
        req.brokerageProjectPossibility =
            values.customer.brokerageProjectPossibility;
        req.portfolio = values.customer.portfolio;
        req.birthplace = values.customer.birthplace;
        req.facebookURL = values.customer.facebookURL;
        req.linkedInURL = values.customer.linkedInURL;
        req.xURL = values.customer.xURL;

        const customer = this.props.state.customer;
        let tags: string[] = customer!.multiSkillTags
            .filter((v) => {
                switch (v.category) {
                    case Multi_SkillTag.Category.Category_IntroductionOperation:
                    case Multi_SkillTag.Category.Category_PersonalConnections:
                    case Multi_SkillTag.Category.Category_DevelopFramework:
                    case Multi_SkillTag.Category.Category_OverseasExpansion:
                    case Multi_SkillTag.Category.Category_Programming:
                    case Multi_SkillTag.Category.Category_AI:
                        return false;
                    default:
                        return true;
                }
            })
            .map((v) => v.id);
        tags = tags.concat(values.tags_1);
        tags = tags.concat(values.tags_7);
        tags = tags.concat(values.tags_5);
        tags = tags.concat(values.tags_3);
        tags = tags.concat(values.tags_4);
        tags = tags.concat(values.tags_6);
        req.multiSkillTagIds = tags;

        this.props.dispatcher.updateCustomer(req);
    };

    // password変更
    private handleUpdatePasswordSubmit = (value: any): void => {
        const req: UpdatePasswordByCustomerRequest =
            new UpdatePasswordByCustomerRequest();
        req.currentPassword = value.currentPassword;
        req.newPassword = value.password;
        this.props.dispatcher.updatePassword(req);
    };

    // Email変更
    private handleUpdateEmailSubmit = (value: any): void => {
        const req: UpdateEmailByCustomerRequest =
            new UpdateEmailByCustomerRequest();
        req.currentPassword = value.currentPassword;
        req.email = value.email;
        this.props.dispatcher.updateEmail(req);
    };

    private handleGenerateCustomerPDF = (): void => {
        const req: GenerateCustomerPDFByCustomerRequest =
            new GenerateCustomerPDFByCustomerRequest();

        this.props.dispatcher.generateCustomerPDF(req);
    };

    private handleDestroyCustomerPDF = (): void => {
        const req: DestroyCustomerPDFByCustomerRequest =
            new DestroyCustomerPDFByCustomerRequest();

        this.props.dispatcher.destroyCustomerPDF(req);
    };
}

const mapStateToProps = (state: AppState) => {
    return {
        state: state.customerMypageReducer,
        authState: state.authReducer,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {
        dispatcher: createCustomerMypageDispatcher(
            dispatch,
            createCustomerMypageActionCreator()
        ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerMypage);



// WEBPACK FOOTER //
// ./src/presentation/container/customer_mypage_container.tsx